import cn from 'classnames';
import texts from '../../deals-history.texts.json';
import { formatPrice } from '../../format/format-price';
import styles from './mobile-list-item.module.scss';
import { formatFloor } from '../../format/format-floor';
import type { CompletedDealItem } from '../../types/mapping';
import { formatAddress } from '../../format/format-address';
import { formatDate } from '../../format/format-date';

type Props = {
  item: CompletedDealItem;
};

export function MobileListItem({ item }: Props) {
  return (
    <li className={styles.item}>
      <div className={styles.row}>
        <span>{formatAddress(item.address)}</span>
        <b data-testid="price">{formatPrice(item.price)}</b>
      </div>
      <div className={cn(styles.row, styles.smallText)}>
        <span className={styles.dotsBetween}>
          <span>{`${item.rooms} ${texts.roomsShort}`}</span>
          {Number.isInteger(item.floor) ? (
            <span>{`${texts.floor} ${formatFloor(item.floor)}`}</span>
          ) : null}
          <span>{`${item.buildingMR} ${texts.buildingMR}`}</span>
          <span>{item.buildYear}</span>
        </span>
        <span className={styles.date}>{formatDate(item.saleDate)}</span>
      </div>
    </li>
  );
}
